<!-- Header -->
<main-version></main-version>

<!-- use https://ui-router.github.io/ng1/docs/latest/classes/transition.transitionservice.html onBefore/success-->
@if (loader.show) {
  <div id="loading" class="alert headalert">Inhalte werden geladen...</div>
}
@if (loader.save) {
  <div id="saving" class="alert alert-info headalert">Inhalte wurden gespeichert!</div>
}

<main-alert></main-alert>

<!-- Navbar -->
<aside id="left-panel" [ngClass]="{tiled: start}">
  <div id="logo-header">
    <div id="logo">
      <a uiSref="start">
        <img src="/ui/assets/images/envisiaERP.png">
      </a>
    </div>
  </div>

  <nav role="navigation" class="h-dvh scrollbar-thin scroll-smooth overflow-x-clip overflow-y-hidden hover:overflow-y-auto focus:overflow-y-auto active:overflow-y-auto">
    @if (start && !hasAnyRights) {
      <div class="error-message">
        <div class="envisiasite">
          <div class="errorsite">
            <div class="error-img"><i class="fa fa-ban text-danger"></i></div>
            <div class="error-status"><h2>Unauthorized</h2>
            <h1>Zugriff verweigert</h1></div>
            <div class="error-message"> Ihnen sind keine Benutzerberechtigungen für diese Anwendung zugeteilt. <br>
              Bitte wenden Sie sich an die Geschäftsleitung oder an den Administrator, falls Sie diese benötigen.
            </div>
            <div class="error-link">
              <button class="btn btn-success btn-lg" (click)="logout()">Abmelden</button>
            </div>
          </div>
        </div>
      </div>
    }


    @if (hasAnyRights) {
      <ul>
        @if (('crm.list'|HasPerm) || ('sales.restricted'|HasPerm)) {
          <li>
            <a evSref="a.crm.list" [ngClass]="{active: state.includes('a.crm')}">
              <div class="icon">
                <i class="fa fa-users"></i>
              </div>
              <div class="icon-label">
                Kunden
              </div>
            </a>
          </li>
        }
        @if (('material.supplier_view'|HasPerm)) {
          <li>
            <a evSref="a.material_supplier" [ngClass]="{active: state.includes('a.material_supplier')}">
              <div class="icon">
                <i class="fa fa-shopping-cart"></i>
              </div>
              <div class="icon-label">
                Lieferanten
              </div>
            </a>
          </li>
        }
        @if (('vendor.view'|HasPerm)) {
          <li>
            <a evSref="a.vendor" [ngClass]="{active: state.includes('a.vendor')}">
              <div class="icon">
                <i class="fa fa-address-card"></i>
              </div>
              <div class="icon-label">
                Dienstleister
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm) || ('task.offer.view'|HasPerm) || ('sales.restricted'|HasPerm)) {
          <li>
            <a evSref="a.workflow.o.list" [ngClass]="{active: state.includes('a.workflow.o')}">
              <div class="icon">
                <i class="fa fa-paper-plane"></i>
              </div>
              <div class="icon-label">
                Angebote
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm) || ('task.offer.view'|HasPerm)) {
          <li>
            <a evSref="a.workflow.c.list" [ngClass]="{active: state.includes('a.workflow.c')}">
              <div class="icon">
                <i class="fa fa-tasks"></i>
              </div>
              <div class="icon-label">
                Aufträge
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm)) {
          <li>
            <a evSref="a.workflow.fetch.list" [ngClass]="{active: state.is('a.workflow.fetch.list')}">
              <div class="icon">
                <i class="fa fa-list"></i>
              </div>
              <div class="icon-label">
                Abrufe
              </div>
            </a>
          </li>
        }
        @if (('task.fetch.list'|HasPerm)) {
          <li>
            <a evSref="a.workflow.fetch.list_cam"
              [evParams]="{order: 'DESC_NULLS_LAST', sort: 'task_workflow_fetch_delivery'}"
              [ngClass]="{active: state.is('a.workflow.fetch.list_cam')}">
              <div class="icon">
                <i class="fa fa-list"></i>
              </div>
              <div class="icon-label">
                Abrufe CAM
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm)) {
          <li>
            <a evSref="a.workflow.kanban.de" [ngClass]="{active: state.includes('a.workflow.kanban.de')}">
              <div class="icon">
                <i class="fa fa-microchip" aria-hidden="true"></i>
              </div>
              <div class="icon-label">
                Kanban DE
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm)) {
          <li>
            <a evSref="a.workflow.kanban.cn" [ngClass]="{active: state.includes('a.workflow.kanban.cn')}">
              <div class="icon">
                <i class="fa fa-microchip" aria-hidden="true"></i>
              </div>
              <div class="icon-label">
                Kanban CN
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm) || ('task.offer.view'|HasPerm)) {
          <li>
            <a evSref="a.inventory.list" [ngClass]="{active: state.includes('a.inventory')}">
              <div class="icon">
                <i class="fa fa-database" aria-hidden="true"></i>
              </div>
              <div class="icon-label">
                Lager
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm) || ('task.offer.view'|HasPerm)) {
          <li>
            <a evSref="a.workflow.contract.list" [ngClass]="{active: state.includes('a.workflow.contract')}">
              <div class="icon">
                <i class="fa fa-handshake-o"></i>
              </div>
              <div class="icon-label">
                Auftr.-Best.
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm) || ('task.offer.view'|HasPerm)) {
          <li>
            <a evSref="a.workflow.d.list" [evParams]="{status: 1}" [ngClass]="{active: state.includes('a.workflow.d')}">
              <div class="icon">
                <i class="fa fa-cube"></i>
              </div>
              <div class="icon-label">
                Lieferscheine
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm) || ('task.offer.view'|HasPerm)) {
          <li>
            <a evSref="a.workflow.i.list" [ngClass]="{active: state.includes('a.workflow.i')}">
              <div class="icon">
                <i class="fa fa-tasks"></i>
              </div>
              <div class="icon-label">
                Rechnungen
              </div>
            </a>
          </li>
        }
        @if (('correction_restricted'|HasPerm) || ('correction_all'|HasPerm)) {
          <li>
            <a evSref="a.correction.ic.list" [ngClass]="{active: state.includes('a.correction.ic')}">
              <div class="icon">
                <i class="fa fa-fast-backward"></i>
              </div>
              <div class="icon-label">
                RG Korrektur
              </div>
            </a>
          </li>
        }
        @if (('opos'|HasPerm)) {
          <li>
            <a evSref="a.workflow.opos_list" [ngClass]="{active: state.includes('a.workflow.opos_list')}">
              <div class="icon">
                <i class="fa fa-money"></i>
              </div>
              <div class="icon-label">
                Offene Posten
              </div>
            </a>
          </li>
        }
        @if (('dunning'|HasPerm)) {
          <li>
            <a evSref="a.dunning.list" [ngClass]="{active: state.includes('a.dunning')}">
              <div class="icon">
                <i class="fa fa-warning"></i>
              </div>
              <div class="icon-label">
                Mahnungen
              </div>
            </a>
          </li>
        }
        @if (('article.detail'|HasPerm)) {
          <li>
            <a evSref="a.article.list" [ngClass]="{active: state.includes('a.article')}">
              <div class="icon">
                <i class="fa fa-qrcode"></i>
              </div>
              <div class="icon-label">
                Artikel
              </div>
            </a>
          </li>
        }
        @if (('article.wizard_create'|HasPerm)) {
          <li>
            <a evSref="a.wizard.article.list" [ngClass]="{active: state.includes('a.wizard.article.list')}">
              <div class="icon h-8">
                <span class="fa fa-stack subscript right">
                  <i class="fa fa-qrcode fa-stack-1x"></i>
                  <i class="fa fa-calendar-plus-o fa-stack-2x dimgray"></i>
                </span>
              </div>
              <div class="icon-label">
                Artikel Freigaben
              </div>
            </a>
          </li>
        }
        @if (('price.detail'|HasPerm) || ('price.change'|HasPerm)) {
          <li>
            <a evSref="a.price.list" [ngClass]="{active: state.includes('a.price')}" (click)="resetPrice($event)">
              <div class="icon">
                <i class="fa fa-balance-scale"></i>
                @if (share.price && ('price.detail'|HasPerm)) {
                  <i class="fa fa-exclamation-triangle red_alert" aria-hidden="true"
                  ></i>
                }
              </div>
              <div class="icon-label">
                Preisprüf.
              </div>
            </a>
          </li>
        }
        @if (('activity.activity'|HasPerm) || ('sales.restricted'|HasPerm)) {
          <li>
            <a evSref="akquise.list" [ngClass]="{active: state.includes('akquise')}">
              <div class="icon">
                <i class="fa fa-calendar"></i>
              </div>
              <div class="icon-label">
                Aktivitäten
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm) || ('task.offer.view'|HasPerm)) {
          <li>
            <a evSref="a.workflow.request.list" [ngClass]="{active: state.includes('a.workflow.request')}">
              <div class="icon">
                <i class="fa fa-percent"></i>
              </div>
              <div class="icon-label">
                Anfragen
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm) || ('task.offer.view'|HasPerm)||('order.list'|HasPerm)) {
          <li>
            <a evSref="a.workflow.order.list"
              [evParams]="{status: 0, order: 'DESC', sort: 'workflow_order_id'}"
              [ngClass]="{active: state.includes('a.workflow.order')}">
              <div class="icon">
                <i class="fa fa-truck"></i>
              </div>
              <div class="icon-label">
                Bestellungen
              </div>
            </a>
          </li>
        }
        @if (('film.inventory.list'|HasPerm)) {
          <li>
            <a evSref="a.film_inventory.list" [ngClass]="{active: state.includes('a.film_inventory')}">
              <div class="icon">
                <i class="fa fa-archive"></i>
              </div>
              <div class="icon-label">
                Filmlager
              </div>
            </a>
          </li>
        }
        @if (('material.transactions'|HasPerm)) {
          <li>
            <a evSref="a.material.inventory.list-select"
           [ngClass]="{active: state.includes('a.material') &&
                              !state.includes('a.material.order') &&
                              !state.includes('a.material.planning')}">
              <div class="icon">
                <i class="fa fa-inbox"></i>
              </div>
              <div class="icon-label">
                Materiallager
              </div>
            </a>
          </li>
        }
        @if (('material.planning.list'|HasPerm)) {
          <li>
            <a evSref="a.material.planning.list.landingpage" [ngClass]="{active: state.includes('a.material.planning')}">
              <div class="icon">
                <i class="fa fa-shopping-cart"></i>
              </div>
              <div class="icon-label">
                Materialplanung
              </div>
            </a>
          </li>
        }
        @if (('material.order.view'|HasPerm)) {
          <li>
            <a evSref="a.material.order.list"
              [evParams]="{'status': 50}"
              [ngClass]="{active: state.includes('a.material.order') && !state.includes('a.material.order.position')}">
              <div class="inline text-nowrap">
                <div class="icon">
                  <i class="fa fa-truck"></i>
                </div>
                <div class="icon-label">
                  Mat. Bestellungen
                </div>
              </div>
            </a>
          </li>
        }
        @if (('material.order.view'|HasPerm)) {
          <li>
            <a evSref="a.material.order.position.list"
              [evParams]="{'status': 50}"
              [ngClass]="{active: state.includes('a.material.order.position')}">
              <div class="icon">
                <i class="fa fa-truck"></i>
              </div>
              <div class="icon-label">
                Mat. Bestell Pos.
              </div>
            </a>
          </li>
        }
        @if (('ba.list'|HasPerm)) {
          <li>
            <a evSref="a.business_order.list" [ngClass]="{active: state.includes('a.business_order')}">
              <div class="icon">
                <i class="fa fa-cogs"></i>
              </div>
              <div class="icon-label">
                Betriebsaufträge
              </div>
            </a>
          </li>
        }
        @if (('ba.adapter.list'|HasPerm)) {
          <li>
            <a evSref="a.adapter.list" [ngClass]="{active: state.includes('a.adapter')}">
              <div class="icon">
                <i class="fa fa-search"></i>
              </div>
              <div class="icon-label">
                Adapterliste
              </div>
            </a>
          </li>
        }
        @if (('label.create'|HasPerm)) {
          <li>
            <a evSref="a.label.create" [ngClass]="{active: state.includes('a.icon-label')}">
              <div class="icon">
                <i class="fa fa-print" aria-hidden="true"></i>
              </div>
              <div class="icon-label">
                Etiketten
              </div>
            </a>
          </li>
        }
        @if (('article.multilayerplan.change'|HasPerm)) {
          <li>
            <a evSref="a.multilayerplan" [ngClass]="{active: state.includes('a.multilayerplan')}">
              <div class="icon">
                <i class="fa fa-signal fa-rotate-90" aria-hidden="true"></i>
              </div>
              <div class="icon-label">
                Aufbauplan
              </div>
            </a>
          </li>
        }
        @if (('printer'|HasPerm)) {
          <li>
            <a evSref="a.print.list" [ngClass]="{active: state.includes('a.print')}" (click)="resetPrintState($event)">
              <div class="icon">
                <i class="fa fa-print" aria-hidden="true"></i>
                @if (share.print_failed && ('printer'|HasPerm)) {
                  <i class="fa fa-exclamation-triangle red_alert" aria-hidden="true"
                  ></i>
                }
              </div>
              <div class="icon-label">
                Druckjobs
              </div>
            </a>
          </li>
        }
        @if (('task.change'|HasPerm)) {
          <li>
            <a evSref="a.jobErrorList"
              [ngClass]="{active: state.includes('a.jobErrorList'), 'job-error': jobErrorsData.value > 0}">
              <div class="icon">
                <i class="fa fa-envelope" aria-hidden="true"></i>
              </div>
              <div class="icon-label">
                Versand Status
              </div>
            </a>
          </li>
        }
        @if (('task.view'|HasPerm)) {
          <li>
            <a evSref="d.cn_order_list">
              <div class="icon">
                <i class="fa fa-industry" aria-hidden="true"></i>
              </div>
              <div class="icon-label">
                Abrufe CN
              </div>
            </a>
          </li>
        }

        @if (('erp.terminal.list'|HasPerm)) {
          <li>
            <a [href]="'/terminal/list' | appHref">
              <div class="icon">
                <i class="fa fa-desktop"></i>
              </div>
              <div class="icon-label">
                Terminals
              </div>
            </a>
          </li>
        }

        @if (start && ('analysis'|HasPerm)) {
          <li>
            <a uiSref="analysis.fetch.overview" [uiParams]="{start: year, end: year}">
              <div class="icon">
                <i class="fa fa-line-chart"></i>
              </div>
              <div class="icon-label">
                Auswertungen
              </div>
            </a>
          </li>
        }
        @if (start && ('analysis.executive'|HasPerm)) {
          <li>
            <a uiSref="analysis.executive.liquidity">
              <div class="icon">
                <i class="fa fa-line-chart green"></i>
              </div>
              <div class="icon-label">
                GF Auswertungen
              </div>
            </a>
          </li>
        }
        @if (start && ('business_order.analysis'|HasPerm)) {
          <li
            >
            <a uiSref="analysis_business_order.step" [uiParams]="{start: year, end: year}">
              <div class="icon">
                <i class="fa fa-line-chart"></i>
              </div>
              <div class="icon-label">
                BA Auswertungen
              </div>
            </a>
          </li>
        }
        @if (start && ('material.analysis'|HasPerm)) {
          <li>
            <a uiSref="analysis_material.inventory">
              <div class="icon">
                <i class="fa fa-line-chart"></i>
              </div>
              <div class="icon-label">
                Material Auswertungen
              </div>
            </a>
          </li>
        }
        @if (start && ('workload.timetable'|HasPerm)) {
          <li>
            <a uiSref="a.workload.timetable">
              <div class="icon">
                <i class="fa fa-line-chart"></i>
              </div>
              <div class="icon-label">
                Auslastungskalender
              </div>
            </a>
          </li>
        }
        @if (start && ('invoice.automation'|HasPerm)) {
          <li>
            <a uiSref="a.workflow.i.invoice">
              <div class="icon">
                <i class="fa fa-eur" aria-hidden="true"></i>
              </div>
              <div class="icon-label">
                Rechnungslauf
              </div>
            </a>
          </li>
        }
        @if (start && ('dunning'|HasPerm)) {
          <li>
            <a uiSref="a.dunning.automation">
              <div class="icon">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              </div>
              <div class="icon-label">
                Mahnungslauf
              </div>
            </a>
          </li>
        }
        @if (start && (('settings.calculation'|HasPerm) || ('settings.price.gold'|HasPerm))) {
          <li>
            <a [uiSref]="('settings.calculation'|HasPerm) ? 'a.calculation.list' : 'a.calculation.gold'">
              <div class="icon">
                <i class="fa fa-table"></i>
              </div>
              <div class="icon-label">
                Kalkulationstabellen
              </div>
            </a>
          </li>
        }
        @if (start) {
          <article-config-redirect type="base"></article-config-redirect>
        }
        @if (start && ('production.machines'|HasPerm)) {
          <li>
            <a uiSref="a.production.machines.list">
              <div class="icon">
                <i class="fa fa-gavel"></i>
              </div>
              <div class="icon-label">
                Produktions Einstellungen
              </div>
            </a>
          </li>
        }
        @if (start && ('article.extra'|HasPerm)) {
          <li>
            <a uiSref="a.holiday.manage">
              <div class="icon">
                <i class="fa fa-calendar"></i>
              </div>
              <div class="icon-label">
                Feiertage
              </div>
            </a>
          </li>
        }
        @if (start && ('material.settings'|HasPerm)) {
          <li>
            <a uiSref="a.material.group.list">
              <div class="icon">
                <i class="fa fa-inbox"></i>
              </div>
              <div class="icon-label">
                Materialverwaltung
              </div>
            </a>
          </li>
        }
        @if (start && ('user.change'|HasPerm)) {
          <li>
            <a uiSref="a.user.list">
              <div class="icon">
                <i class="fa fa-user"></i>
              </div>
              <div class="icon-label">
                Benutzerverwaltung
              </div>
            </a>
          </li>
        }
        @if (start && ('label.settings'|HasPerm)) {
          <li>
            <a uiSref="a.label.settings">
              <div class="icon">
                <i class="fa fa-print"></i>
              </div>
              <div class="icon-label">
                Etiketteneinstellungen
              </div>
            </a>
          </li>
        }
        @if (start && ('settings.settings'|HasPerm)) {
          <li>
            <a uiSref="a.config.main">
              <div class="icon">
                <span class="fa fa-stack subscript right">
                  <i class="fa fa-cog fa-stack-1x dimgray"></i>
                  <i class="fa fa-cog fa-stack-2x"></i>
                </span>
              </div>
              <div class="icon-label">
                System Einstellungen
              </div>
            </a>
          </li>
        }
        @if (start && ('settings.settings'|HasPerm)) {
          <li>
            <a uiSref="a.config.price_increase_flex">
              <div class="icon">
                <span class="fa fa-stack subscript right">
                  <i class="fa fa-cog fa-stack-1x dimgray"></i>
                  <i class="fa fa-euro fa-stack-2x"></i>
                </span>
              </div>
              <div class="icon-label">
                Kosten Einstellungen
              </div>
            </a>
          </li>
        }
        @if (start && (
          ('field_service.config'|HasPerm) ||
          ('settings.customer.industrial_sectors'|HasPerm) ||
          ('settings.customer.departments'|HasPerm) ||
          ('task.offer.rejection.reason.change'|HasPerm) ||
          ('price.increase.global'|HasPerm))) {
          <li>
            <a uiSref="a.config.customer">
              <div class="icon">
                <span class="fa fa-stack subscript right">
                  <i class="fa fa-cog fa-stack-1x dimgray"></i>
                  <i class="fa fa-user fa-stack-2x"></i>
                </span>
              </div>
              <div class="icon-label">
                Kunden Einstellungen
              </div>
            </a>
          </li>
        }
        @if (start && ('settings.settings'|HasPerm)) {
          <li>
            <a uiSref="a.config.pdf_text">
              <div class="icon">
                <span class="fa fa-stack subscript right">
                  <i class="fa fa-file-o fa-stack-1x dimgray"></i>
                  <i class="fa fa-user fa-stack-2x"></i>
                </span>
              </div>
              <div class="icon-label">
                Kunden Dokumente
              </div>
            </a>
          </li>
        }
        @if (start && ('ba.list'|HasPerm)) {
          <li>
            <a uiSref="a.dashboard.main" [uiParams]="{dashboard: true}">
              <div class="icon">
                <i class="fa fa-tasks"></i>
              </div>
              <div class="icon-label">
                Dashboard
              </div>
            </a>
          </li>
        }
        @if (start && ('plotting.list'|HasPerm)) {
          <li>
            <a [href]="'/dashboard/plotting' | appHref">
              <div class="icon">
                <span class="fa fa-stack subscript right">
                  <i class="fa fa-file-picture-o fa-stack-1x dimgray"></i>
                  <i class="fa fa-tasks fa-stack-2x"></i>
                </span>
              </div>
              <div class="icon-label">
                Plotting Dashboard
              </div>
            </a>
          </li>
        }
        @if ('embp_dashboard'|HasPerm) {
          <li>
            <a uiSref="a.dashboard.empb">
              <div class="icon">
                <span class="fa fa-stack subscript right">
                  <i class="fa fa-file-text-o fa-stack-1x dimgray"></i>
                  <i class="fa fa-tasks fa-stack-2x"></i>
                </span>
              </div>
              <div class="icon-label">
                EMPB Dashboard
              </div>
            </a>
          </li>
        }
        @if (start && (('export.customer.contact'|HasPerm) || ('business_order.analysis'|HasPerm))) {
          <li>
            <a uiSref="a.export">
              <div class="icon">
                <i class="fa fa-download"></i>
              </div>
              <div class="icon-label">
                Export
              </div>
            </a>
          </li>
        }
        @if (start && ('cluster.administration.info'|HasPerm)) {
          <li>
            <a uiSref="a.cluster.info">
              <div class="icon">
                <i class="fa fa-server"></i>
              </div>
              <div class="icon-label">
                Cluster Informationen
              </div>
            </a>
          </li>
        }
        @if (start) {
          <li>
            <a class="click" (click)="logout(true)">
              <div class="icon">
                <i class="fa fa-sign-out" aria-hidden="true"></i>
              </div>
              <div class="icon-label">
                Abmelden
              </div>
            </a>
          </li>
        }
      </ul>
    }
  </nav>
</aside>

@if (!start) {
  <div id="main">
    <div id="content">
      <div id="header">
        <div class="buttonbar">
          <!-- Segment: Maybe a top bar -->
          <ui-view name="navigation"></ui-view>
        </div>
        <main-dropdown></main-dropdown>
      </div>
      <div class="main-view">
        <ui-view name="main"></ui-view>
        <ui-view></ui-view>
      </div>
    </div>
  </div>
}
